<template>
	<div>
		<div class="promotionContent">
			<prdClassify v-model="classifyList"></prdClassify>
			<prdList v-model="prdData"></prdList>
		</div>
		<select-data-panel
			style="margin-bottom: 30px"
			v-if="classifyList.length || prdData.length"
			:classifyList="classifyList"
			:prdData="prdData"
			@handleClose="handleClose"
			@close_prd="close_prd"
		></select-data-panel>

		<confirmStep :activeValue="1" @toNext="toNext" @toSkip="toSkip"></confirmStep>
	</div>
</template>
<script>
import adsNewOnline from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
import prdClassify from '@/components/adsOnlineAuto/com/prdClassify';
import prdList from '@/components/adsOnlineAuto/com/prdList';
import selectDataPanel from '@/components/adsOnlineAuto/com/select-data-panel';
import confirmStep from '@/components/adsOnlineAuto/confirmStep';
import vm from '@/common/confirm.js';
export default {
	data() {
		return {
			classifyList: [],
			prdData: [],
		};
	},
	components: { prdClassify, prdList, selectDataPanel, confirmStep },
	computed: {
		queryParam() {
			return this.$route.query;
		},
		id(){
			return this.$route.query.id;
		}
	},
	methods: {
		toSkip() {
			this.$emit('toSkip', 6);
		},
		handleClose(index) {
			this.classifyList.splice(index, 1);
		},
		close_prd(index) {
			this.prdData.splice(index, 1);
		},
		toNext() {
			if (this.classifyList.length || this.prdData.length) {
				try {
					this.addproduct();
				} catch (error) {
					console.log(error);
				}
			} else {
				vm._warn('请选择产品分类和产品');
			}
		},
		async addproduct() {
			
			let param = {
				automationId: this.id,
				productList: this.prdData,
				productTypeList: this.classifyList,
				showFlag:0,
			};
			let res = await adsNewOnline.addproduct(param);
			if (res.data == 'success') {
				this.$store.dispatch('getstepstatus',this.id);
				this.$emit('toNext');
				
			}
		},
		async getproduct() {
			let res = await adsNewOnline.getproduct({
				id: this.id,
			});
			this.classifyList = res.data.productTypeList;
			this.prdData = res.data.productList;
		},
	},
	created() {
		this.getproduct();
	},
};
</script>

<style lang="scss" scoped>
.promotionContent {
	padding: 25px;
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	border-radius: 4px;
	height: auto;
}
</style>
